import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, timer } from 'rxjs';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class SessionTimeoutService {
  private readonly SESSION_TIMEOUT = 20 * 60 * 1000; // 20 minutes in milliseconds
  private timeoutId: any;
  private subscription: Subscription | null = null;
  private sessionExpired = new BehaviorSubject<boolean>(false);
  
  sessionExpired$ = this.sessionExpired.asObservable();

  constructor(private msalService: MsalService) {}

  startSessionTimer(): void {
    this.resetTimer();
    
    // Setup event listeners for user activity
    window.addEventListener('mousemove', this.resetTimerBound);
    window.addEventListener('mousedown', this.resetTimerBound);
    window.addEventListener('keypress', this.resetTimerBound);
    window.addEventListener('touchmove', this.resetTimerBound);
    window.addEventListener('scroll', this.resetTimerBound);
  }

  private resetTimerBound = this.resetTimer.bind(this);

  private resetTimer(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    
    this.subscription = timer(this.SESSION_TIMEOUT).subscribe(() => {
      this.sessionExpired.next(true);
    });
  }

  stopSessionTimer(): void {
    window.removeEventListener('mousemove', this.resetTimerBound);
    window.removeEventListener('mousedown', this.resetTimerBound);
    window.removeEventListener('keypress', this.resetTimerBound);
    window.removeEventListener('touchmove', this.resetTimerBound);
    window.removeEventListener('scroll', this.resetTimerBound);
    
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  logout(): void {
    this.sessionExpired.next(false);
    this.msalService.logout();
  }
}
